import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file-list-sql",
  "use": "icon-file-list-sql-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-file-list-sql\"><defs><style type=\"text/css\"></style></defs><path d=\"M900.7 391c0 68.9-159.9 146.6-390.9 146.6S121.1 459.9 121.1 391V240c71.1 62.2 215.5 102.2 390.9 102.2 173.3 0 317.6-40 390.9-102.2v151h-2.2z m-779.6 91.1c71.1 62.2 215.5 102.2 390.9 102.2 173.3 0 317.6-40 390.9-102.2v151C902.9 702 743 779.7 512 779.7S121.1 702 121.1 633.1v-151zM512 0c228.8 0 390.9 77.7 390.9 146.6S743 293.3 512 293.3s-390.9-77.7-390.9-146.6S281 0 512 0zM121.1 877.4v-151c71.1 62.2 215.5 102.2 390.9 102.2 173.3 0 317.6-40 390.9-102.2v151C902.9 946.3 743 1024 512 1024s-390.9-77.7-390.9-146.6z\" p-id=\"13042\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/file-list-sql.svg
// module id = prLD
// module chunks = 20